// @flow
import { SubscriptionsActionType, SubscriptionsByOuidType } from './types';

export const fetchAll = (): SubscriptionsActionType => ({
  type: 'SUBSCRIPTION_FETCH_ALL',
});

export const fetchAllSuccess = (subscriptionsByOuid: SubscriptionsByOuidType): SubscriptionsActionType => ({
  type: 'SUBSCRIPTION_FETCH_ALL_SUCCESS',
  payload: {
    subscriptionsByOuid,
  },
});

export const fetchAllFailure = (e: Object): SubscriptionsActionType => ({
  type: 'SUBSCRIPTION_FETCH_ALL_FAILURE',
  payload: e,
  error: true,
});

export const setSubscriptionToUpdate = (subscriptionToUpdateOuid: string = ''): SubscriptionsActionType => ({
  type: 'SET_SUBSCRIPTION_TO_UPDATE',
  payload: { subscriptionToUpdateOuid },
});

export const updateSelectedSubscription = (newOffer: Object): SubscriptionsActionType => ({
  type: 'UPDATE_SELECTED_SUBSCRIPTION',
  payload: {
    newOffer,
  },
});
